<template>
    <div class="article-terms-definitions">
        <p>
            In this policy, ‘we’, ‘us’, ‘our’ and ‘Swing Renegades’ refer to Swing Renegades Ltd. The term 'Our Events'
            refers to any events that Swing Renegades manage which are advertised on this website and not explicitly
            stated as an external event.
        </p>
        <p>
            The term 'The Network' refers to this website and any associated social media groups managed by Swing
            Renegades.
        </p>
        <p>The term 'External Events' refers to any events not managed by Swing Renegades.</p>
        <p>
            The term 'Swing Renegades Member' refers to any individual registered on this website or who has attended
            one of Our Events.
        </p>
        <p>
            The term 'Swing Renegades Team' refers to the individuals appointed as responsible for the management and
            delivery of Our Events.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleTermsDefinitions',
};
</script>
